import React from "react";
import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { FailedDeliveryAttempt } from "./instantAnswersComponents/orders/FailedDeliveryAttemptIA";
export var failedDeliveryAttempt = function failedDeliveryAttempt(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return FAILED_DELIVERY_ATTEMPT_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return FAILED_DELIVERY_ATTEMPT_DESCRIPTION();
    }
  };
};
var FAILED_DELIVERY_ATTEMPT_TITLE = function FAILED_DELIVERY_ATTEMPT_TITLE(strictLocalize) {
  return strictLocalize({
    id: "13w1zw",
    defaultMessage: [{
      "type": 0,
      "value": "Tentativa de entrega sem sucesso"
    }]
  });
};
var FAILED_DELIVERY_ATTEMPT_DESCRIPTION = function FAILED_DELIVERY_ATTEMPT_DESCRIPTION() {
  return /*#__PURE__*/React.createElement(FailedDeliveryAttempt, null);
};